module.exports = __webpack_public_path__ + "img/horizontal_6_7_8003.919ced7f.png";